import { css, createGlobalStyle } from 'styled-components'

export const button = css`
  button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    -webkit-appearance: none;
    appearance: none;
    border: none;
  }
`
//   button {
//     position: relative;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 6px 12px;
//     min-height: 36px;
//     background-color: ${({ theme }) => theme.colors.teal};
//     border: none;
//     font-family: ${({ theme }) => theme.fonts.normal};
//     font-size: 0.8em;
//     font-weight: 400;
//     line-height: 20px;
//     letter-spacing: 2px;
//     white-space: nowrap;
//     vertical-align: middle;
//     cursor: pointer;
//     user-select: none;
//     background-repeat: repeat-x;
//     background-position: -1px -1px;
//     background-size: 110% 110%;
//     appearance: none;
//     border-radius: 4px;
//     text-decoration: none;
//     transform: perspective(1px) translateZ(0);
//     box-shadow: 0 0 1px rgba(0, 0, 0, 0);
//     transition: all 0.2s;

//     svg:nth-of-type(1) {
//       margin: -6px 4px -6px 0px;
//     }

//     svg:nth-of-type(2) {
//       margin: -6px 0px -6px 4px;
//     }

//     @keyframes ripple-out {
//       100% {
//         top: -6px;
//         right: -6px;
//         bottom: -6px;
//         left: -6px;
//         opacity: 0;
//       }
//     }
//   }
// `

export const Button = createGlobalStyle`${button}`
